module.exports = __webpack_public_path__ + "static/img/6.55ad9f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/eng/6.png
// module id = 0szq
// module chunks = 0